import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  titulo: {
    fontSize: '1.25rem !important',
    fontWeight: '500 !important',
    lineHeight: '2rem !important'
  },
  subTitulo: {
    fontSize: '0.875rem !important',
    color: '#616161',
    lineHeight: '1.375rem !important',
    fontWeight: '500 !important'
  },
  gridAvtItm:{
    marginTop: '1.5rem', 
    marginBottom: '1.5rem',
  },
  avatar:{
    color: '#2813AD !important',
    backgroundColor: '#F4F3FB !important',
    fontSize: '1.5rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.375rem !important',
    width: '4.81rem !important',
    height: '4.81rem !important',
  },
  nome: {
    margin: '0px !important', 
    fontSize: '1rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.6rem !important'
  },
  email: {
    margin: '0px', 
    fontSize: '0.875rem !important', 
    color: '#B0B0B0 !important',
    fontWeight: '500 !important',
    lineHeight: '1.375rem'
  },
  itemText:{
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  gridCircularProgress:{
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-evenly', 
    alignItems: 'center', 
    height: '100%'
  }
}));